import { } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { QuickBooksObjectDataset } from 'app/model/dataset/quick-books.dataset';
import { TabularCopySource } from './tabular-type.copysource';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.quickBooks.copySourceType,
    display: [],
    tags: { datasetModel: Metamodel.modelFor(QuickBooksObjectDataset) }
})
export class QuickBooksCopySource extends TabularCopySource {
}
